export const FETCH_FACTORY_EVALUATION = 'FETCH_FACTORY_EVALUATION';
export const FILTER_FACTORY_EVALUATION = 'FILTER_FACTORY_EVALUATION';